import { useCallback } from "react";
import { combineRefs } from "../combine-refs";
export const useCombineRefs = (refA, refB) => 
// eslint-disable-next-line react-hooks/exhaustive-deps -- maybe combineRefs obfuscates the functional internals?
useCallback(combineRefs(refA, refB), 
// See implementation note here:
// https://github.com/facebook/react/issues/15884#issuecomment-522624757
[refA, refB]);
